export default {
  getAllEmailTemplate: [],
  getEmailConfig: [],
  valueTemplate: "",
};
